/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { useEffect, useState } from 'react';
import {
  Button,
  Form,
  Input,
  Message,
  Modal,
  Popconfirm,
  Radio,
  Select,
  Space,
  Switch,
  Table,
  TableColumnProps,
  Typography
} from '@arco-design/web-react';
import './index.scss';
import { payTypeMap, payTypeOption } from '../const';
import { get, post } from '../requestNew';
import PhoneCell from '../components/PhoneCell';
import { AddItem, Item } from './types';

// 订单状态映射
const orderStatusMap: Record<string, string> = {
  SUCCESS: '支付成功',
  REFUND: '转入退款',
  NOTPAY: '未支付',
  CLOSED: '已关闭',
  REVOKED: '已撤销（付款码）',
  USERPAYING: '用户支付中（付款码）',
  PAYERROR: '支付失败（付款码）'
};

// 订单状态选项
const orderStatusOptions = [
  { label: '全部', value: 'ALL' },
  { label: '支付成功', value: 'SUCCESS' },
  { label: '未支付', value: 'NOTPAY' },
  { label: '转入退款', value: 'REFUND' },
  { label: '已关闭', value: 'CLOSED' },
  { label: '已撤销（付款码）', value: 'REVOKED' },
  { label: '用户支付中（付款码）', value: 'USERPAYING' },
  { label: '支付失败（付款码）', value: 'PAYERROR' }
];

const RadioGroup = Radio.Group;
const Option = Select.Option;
const FormItem = Form.Item;

const formItemLayout = {
  labelCol: {
    span: 6
  },
  wrapperCol: {
    span: 16
  }
};

function Pay(props: any) {
  const { groupTypeOption, groupTypeMap } = props;
  const [formAdd] = Form.useForm<AddItem>();
  const [formEdit] = Form.useForm<Item>();
  const [loading, setLoading] = useState(false);
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleEdit, setVisibleEdit] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [sessionList, setSessionList] = useState<{ label: string; value: string }[]>([]);
  const [gameSessions, setGameSessions] = useState<string[]>([]);
  const [gameName, setGameName] = useState('');
  const [phone, setPhone] = useState('');
  /** 列表筛选：按用户 openId 精确/模糊由后端决定 */
  const [openIdFilter, setOpenIdFilter] = useState('');
  /** 列表筛选：按用户 oneId 查询 */
  const [oneIdFilter, setOneIdFilter] = useState('');
  const [orderIdFilter, setOrderIdFilter] = useState('');
  const [transactionIdFilter, setTransactionIdFilter] = useState('');
  const [groupType, setGroupType] = useState('');
  const [payType, setPayType] = useState(0);
  const [orderStatus, setOrderStatus] = useState('ALL');
  /** 付费进群：全部传 null，是/否传 true/false */
  const [hasPayForGroup, setHasPayForGroup] = useState<boolean | null>(null);
  const [dataList, setDataList] = useState<Item[]>([]);
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [total, setTotal] = useState(0);
  const [editPhone, setEditPhone] = useState('');

  const columns: TableColumnProps[] = [
    {
      title: '赛季',
      dataIndex: 'gameSession',
      width: 90
    },
    {
      title: 'openId',
      dataIndex: 'openId',
      width: 160
    },
    {
      title: 'oneId',
      dataIndex: 'oneId',
      width: 120,
      render: text => (text ? text : '-')
    },
    {
      title: '报名时间',
      dataIndex: 'signUpTime',
      width: 120
    },
    {
      title: '手机号',
      dataIndex: 'phone',
      width: 160,
      render: text => <PhoneCell phone={text} />
    },
    {
      title: '参赛名',
      dataIndex: 'gameName',
      width: 120
    },

    {
      title: '标签',
      dataIndex: 'communityInfo',
      width: 80
    },
    {
      title: '置顶',
      dataIndex: 'isTop',
      width: 60,
      render: text => (text === 1 ? <span className="blue">是</span> : <span>否</span>)
    },
    {
      title: '是否验证',
      dataIndex: 'verified',
      width: 90,
      render: text => (text === 1 ? <span className="blue">已验证</span> : <span>未验证</span>)
    },
    {
      title: '分组',
      dataIndex: 'groupType',
      width: 80,
      render: text => groupTypeMap[text] || ''
    },
    {
      title: '付费进群',
      dataIndex: 'hasPayForGroup',
      width: 80,
      render: text => text === 1 ? <span className="green">是</span> : <span>否</span>
    },
    {
      title: '状态',
      dataIndex: 'orderStatus',
      width: 120,
      render: text => {
        const statusText = orderStatusMap[text] || text || '未知';
        // 根据状态设置不同的颜色
        let textType: 'primary' | 'success' | 'warning' | 'error' | 'secondary' = 'secondary';
        if (text === 'SUCCESS') {
          textType = 'success';
        } else if (text === 'NOTPAY' || text === 'PAYERROR') {
          textType = 'error';
        } else if (text === 'USERPAYING') {
          textType = 'warning';
        } else if (text === 'REFUND' || text === 'CLOSED' || text === 'REVOKED') {
          textType = 'secondary';
        }else{
          textType = 'error';
        }
        return <Typography.Text type={textType}>{statusText}</Typography.Text>;
      }
    },
    {
      title: '订单ID',
      dataIndex: 'orderId',
      width: 200,
      render: v =>
        v ? (
          <Typography.Text copyable style={{ margin: 0 }}>
            {v}
          </Typography.Text>
        ) : (
          '-'
        )
    },
    {
      title: '虚拟支付订单ID',
      dataIndex: 'transactionId',
      width: 220,
      render: v =>
        v ? (
          <Typography.Text copyable style={{ margin: 0 }}>
            {v}
          </Typography.Text>
        ) : (
          '-'
        )
    },
    {
      title: '备注',
      dataIndex: 'playerDesc',
      width: 80
    },
    {
      title: '操作',
      dataIndex: 'action',
      width: 80,
      render: (_, record: Item) => (
        <>
          <Button className="btn" type="text" onClick={() => edit(record)}>
            修改
          </Button>
          {record.orderStatus !== 'SUCCESS' && (
            <Button className="btn gap" type="text" onClick={() => refreshStatus(record)} disabled={!record.prepayId}>
              刷新状态
            </Button>
          )}
          <Popconfirm
            title="提示"
            content="确认删除?"
            onOk={() => {
              del(record.id);
            }}
          >
            <Button className="btn" type="text" status="danger">
              删除
            </Button>
          </Popconfirm>
        </>
      )
    }
  ];

  const refreshStatus = (record: Item) => {
    const { prepayId, id } = record;
    get('/wechat/pay/getAndUpdateOrderStatus', { prepayId })
      .then((res: any) => {
        const { code, data, message } = res || {};
        if (code === 200 && data) {
          const { orderStatus: status } = data;
          const list = [...dataList];
          const idx = list.findIndex(item => item.id === id);
          list[idx].orderStatus = status;
          setDataList(list);
        } else {
          Message.error(message);
        }
      })
      .catch(e => console.log(e));
  };

  const nickNameChange = (val: string) => {
    setGameName(val.trim());
    setCurrent(1); // 重置到第一页
  };

  const handlePhoneChange = (val: string) => {
    setPhone(val.trim());
    setCurrent(1); // 重置到第一页
  };

  const handleOpenIdFilterChange = (val: string) => {
    setOpenIdFilter(val.trim());
    setCurrent(1);
  };

  const handleOneIdFilterChange = (val: string) => {
    setOneIdFilter(val.trim());
    setCurrent(1);
  };

  const handleOrderIdFilterChange = (val: string) => {
    setOrderIdFilter(val.trim());
    setCurrent(1);
  };

  const handleTransactionIdFilterChange = (val: string) => {
    setTransactionIdFilter(val.trim());
    setCurrent(1);
  };

  const handleGroupTypeChange = (val: string) => {
    setGroupType(val);
    setCurrent(1); // 重置到第一页
  };

  const handlePayTypeChange = (val: number) => {
    setPayType(val);
    setCurrent(1); // 重置到第一页
  };

  const handleOrderStatusChange = (val: string) => {
    setOrderStatus(val);
    setCurrent(1); // 重置到第一页
  };

  const handleHasPayForGroupChange = (val: boolean | null) => {
    setHasPayForGroup(val);
    setCurrent(1);
  };

  const handleReset = () => {
    setGameName('');
    setPhone('');
    setOpenIdFilter('');
    setOneIdFilter('');
    setOrderIdFilter('');
    setTransactionIdFilter('');
    setGroupType('');
    setPayType(0);
    setOrderStatus('ALL');
    setHasPayForGroup(null);
    setCurrent(1);
    // 重置后重新获取数据
    setTimeout(() => {
      getList(true, 1, pageSize);
    }, 0);
  };

  const handlePageChange = (page: number, size?: number) => {
    setCurrent(page);
    if (size && size !== pageSize) {
      setPageSize(size);
      getList(false, page, size);
    } else {
      getList(false, page, size || pageSize);
    }
  };

  // 如果后端支持筛选，直接使用dataList；否则需要前端筛选
  // 这里假设后端支持筛选，所以直接使用dataList
  const list = dataList;

  const getList = (needLoading = false, page = current, size = pageSize) => {
    if (!gameSessions.length) {
      setDataList([]);
      setTotal(0);
      return;
    }

    if (needLoading) {
      setDataList([]);
      setLoading(true);
    }

    const params: any = {
      gameSessions,
      pageNum: page,
      // current: page,
      pageSize: size
    };

    // 添加筛选参数
    if (gameName) params.gameName = gameName.trim();
    if (phone) params.phone = phone.trim();
    if (openIdFilter) params.openId = openIdFilter;
    if (oneIdFilter) params.oneId = oneIdFilter;
    if (orderIdFilter) params.orderId = orderIdFilter;
    if (transactionIdFilter) params.transactionId = transactionIdFilter;
    if (groupType) params.groupType = groupType;
    if (payType) params.payType = payType;
    if (orderStatus !== 'ALL') params.orderStatus = orderStatus;
    params.hasPayForGroup = hasPayForGroup;

    get('/sys/umsUserQualifications/getUserList', params)
      .then((res: any) => {
        const { code, data, message } = res || {};
        if (code === 200) {
          // 如果后端返回分页数据
          if (data && typeof data === 'object' && 'records' in data) {
            const list = (data.records || []).map((obj: any) => ({ ...obj, groupType: `${obj.groupType}` }));
            setDataList(list);
            setTotal(data.total || 0);
          } else {
            // 兼容旧格式：直接返回数组
            const list = (data || []).map((obj: any) => ({ ...obj, groupType: `${obj.groupType}` }));
            setDataList(list);
            setTotal(list.length);
          }
        } else {
          Message.error(message);
        }
      })
      .catch(e => {
        Message.error('网络错误!');
        console.log(e);
      })
      .finally(() => setLoading(false));
  };

  const addPhone = (params: AddItem) => {
    post('/sys/umsUserQualifications/addUserData', { ...params, gameSession: gameSessions[0] })
      .then((res: any) => {
        const { code, message } = res || {};
        if (code === 200) {
          Message.success('保存成功！');
          addCancel();
          getList(true, current, pageSize);
        } else {
          Message.error(message);
        }
      })
      .catch(() => {
        Message.error('网络错误!');
      })
      .finally(() => {
        setConfirmLoading(false);
      });
  };

  const addCancel = () => {
    setVisibleAdd(false);
    setConfirmLoading(false);
    formAdd.resetFields();
  };

  const onAdd = () => {
    formAdd
      .validate()
      .then(res => {
        setConfirmLoading(true);
        addPhone(res);
      })
      .catch(e => {
        console.log(e);
      });
  };

  // 修改相关
  const edit = (record: Item) => {
    setEditPhone(record.phone || '');
    formEdit.setFieldsValue({
      ...record,
      isTopSwitch: !!record.isTop,
      verifiedSwitch: record.verified == 1
    });
    setVisibleEdit(true);
  };
  const editUser = (data: Item) => {
    post('/sys/umsUserQualifications/updateUserById', data)
      .then((res: any) => {
        const { code, message } = res || {};
        if (code === 200) {
          Message.success('保存成功！');
          editCancel();
          getList(true, current, pageSize);
        } else {
          Message.error(message);
        }
      })
      .catch(() => {
        Message.error('网络错误!');
      })
      .finally(() => {
        setConfirmLoading(false);
      });
  };

  const del = (id: number) => {
    get('/sys/umsUserQualifications/delUserById', { id }).then(res => {
      if (res) {
        getList(true, current, pageSize);
      }
    });
  };
  const onEdit = () => {
    formEdit
      .validate()
      .then(res => {
        const isTop = res.isTopSwitch ? 1 : 0;
        const verified = res.verifiedSwitch ? 1 : 0;
        setConfirmLoading(true);
        editUser({ ...res, phone: editPhone || res.phone, isTop, verified });
      })
      .catch(e => {
        console.log(e);
      });
  };

  const editCancel = () => {
    setVisibleEdit(false);
    setConfirmLoading(false);
    setEditPhone('');
    formEdit.resetFields();
  };

  useEffect(() => {
    if (gameSessions.length) {
      getList(true, 1, pageSize);
    }
  }, [gameSessions]);

  // 当筛选条件变化时，重新获取数据（重置到第一页）
  useEffect(() => {
    if (gameSessions.length) {
      // 使用防抖，避免频繁请求
      const timer = setTimeout(() => {
        setCurrent(1);
        getList(true, 1, pageSize);
      }, 300);
      return () => clearTimeout(timer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gameName, phone, openIdFilter, oneIdFilter, orderIdFilter, transactionIdFilter, groupType, payType, orderStatus, hasPayForGroup]);

  useEffect(() => {
    get('/gameConfig/getUmsGameConfigList').then((res: any) => {
      if (res && res.data ) {
        const list = res.data.map((item: any) => {
          const { gameSession } = item;
          return { label: gameSession, value: gameSession };
        });
        setSessionList(list);
        setGameSessions([list[0].value]);
      }
    });
  }, []);

  const filterGroup = [{ label: '全部', value: '' }, ...groupTypeOption];

  return (
    <div className="pay table-flex">
      <Space style={{ flexWrap: 'wrap' }}>
        <div className="filter-item">
          <Typography.Text>赛季:</Typography.Text>
          <Select
            mode="multiple"
            maxTagCount={2}
            allowClear
            onChange={setGameSessions}
            value={gameSessions}
            style={{ width: 135, minWidth: 135 }}
          >
            {sessionList.map(item => (
              <Option value={item.value} key={item.value}>
                {item.label}
              </Option>
            ))}
          </Select>
        </div>
        <div className="filter-item">
          <Typography.Text>订单ID:</Typography.Text>
          <Input value={orderIdFilter} onChange={handleOrderIdFilterChange} style={{ width: 180 }} allowClear placeholder="选填" />
        </div>
        <div className="filter-item">
          <Typography.Text>虚拟支付订单ID:</Typography.Text>
          <Input value={transactionIdFilter} onChange={handleTransactionIdFilterChange} style={{ width: 200 }} allowClear placeholder="选填" />
        </div>
        <div className="filter-item">
          <Typography.Text>参赛名:</Typography.Text>
          <Input value={gameName} onChange={nickNameChange} style={{ width: 120 }} allowClear />
        </div>
        <div className="filter-item">
          <Typography.Text>手机号:</Typography.Text>
          <Input value={phone} onChange={handlePhoneChange} style={{ width: 120 }} allowClear />
        </div>
        <div className="filter-item">
          <Typography.Text>openId:</Typography.Text>
          <Input value={openIdFilter} onChange={handleOpenIdFilterChange} style={{ width: 160 }} allowClear placeholder="选填" />
        </div>
        <div className="filter-item">
          <Typography.Text>oneId:</Typography.Text>
          <Input value={oneIdFilter} onChange={handleOneIdFilterChange} style={{ width: 160 }} allowClear placeholder="选填" />
        </div>
        <div className="filter-item">
          <Typography.Text>分组:</Typography.Text>
          <RadioGroup options={filterGroup} type="button" value={groupType} onChange={handleGroupTypeChange} />
        </div>
        {/* <div className="filter-item">
          <Typography.Text>来源:</Typography.Text>
          <RadioGroup options={payTypeOption} type="button" value={payType} onChange={handlePayTypeChange} />
        </div> */}
        <div className="filter-item">
          <Typography.Text>状态:</Typography.Text>
          <Select
            value={orderStatus}
            onChange={handleOrderStatusChange}
            style={{ width: 150 }}
            allowClear
            placeholder="请选择状态"
          >
            {orderStatusOptions.map(item => (
              <Option value={item.value} key={item.value}>
                {item.label}
              </Option>
            ))}
          </Select>
        </div>
        <div className="filter-item">
          <Typography.Text>付费进群:</Typography.Text>
          <Select
            value={hasPayForGroup === null ? 'ALL' : hasPayForGroup ? 'true' : 'false'}
            onChange={(v: string) => {
              if (v === 'ALL') handleHasPayForGroupChange(null);
              else handleHasPayForGroupChange(v === 'true');
            }}
            style={{ width: 100 }}
            placeholder="请选择"
          >
            <Option value="ALL">全部</Option>
            <Option value="true">是</Option>
            <Option value="false">否</Option>
          </Select>
        </div>
        <Button
          className="filter-item"
          type="primary"
          onClick={() => {
            setVisibleAdd(true);
          }}
        >
          添加
        </Button>
        <Button
          className="filter-item"
          type="primary"
          onClick={() => {
            getList(true, current, pageSize);
          }}
        >
          查询
        </Button>
        <Button className="filter-item" type="outline" onClick={handleReset}>
          重置
        </Button>
      </Space>
      <div className="table-content">
        <Table
          loading={loading}
          columns={columns}
          data={list}
          pagination={{
            current,
            pageSize,
            total,
            sizeCanChange: true,
            sizeOptions: [50, 100, 200],
            showTotal: true,
            onChange: handlePageChange,
            onPageSizeChange: (size: number) => handlePageChange(1, size)
          }}
          rowKey="id"
          className="table-scroll"
          scroll={{ y: '100%', x: '100%' }}
        />
      </div>
      <Modal title="添加手机号" visible={visibleAdd} onOk={onAdd} confirmLoading={confirmLoading} onCancel={addCancel}>
        <Form {...formItemLayout} form={formAdd}>
          <FormItem label="手机号" field="phone" rules={[{ required: true }]}>
            <Input placeholder="" />
          </FormItem>
        </Form>
      </Modal>
      <Modal title="数据修改" visible={visibleEdit} onOk={onEdit} confirmLoading={confirmLoading} onCancel={editCancel}>
        <Form {...formItemLayout} form={formEdit}>
          <FormItem label="id" field="id" hidden>
            <Input placeholder="" />
          </FormItem>
          <FormItem label="手机号">
            <PhoneCell phone={editPhone} />
          </FormItem>
          <FormItem label="参赛名" field="gameName" rules={[{ required: true }]}>
            <Input placeholder="" />
          </FormItem>
          <FormItem label="分组" field="groupType" rules={[{ required: true }]}>
            <RadioGroup options={groupTypeOption} type="button" />
          </FormItem>
          <FormItem label="备注" field="playerDesc">
            <Input placeholder="" maxLength={4} />
          </FormItem>
          <FormItem label="标签" field="communityInfo">
            <Input placeholder="" />
          </FormItem>
          <FormItem label="成绩是否验证" field="verifiedSwitch">
            <Switch />
          </FormItem>
          <FormItem label="置顶" field="isTopSwitch" triggerPropName="checked">
            <Switch />
          </FormItem>
        </Form>
      </Modal>
    </div>
  );
}

export default Pay;
